import { ButtonSize } from "@components/button/button-constants";
import { ToggleButtonGroup } from "@components/toggle-button-group/toggle-button-group";
import { ToggleButtonGroupTheme } from "@components/toggle-button-group/toggle-button-group-constants";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

// Switches a Career Tracks page between previewing and editing. The caller's
// onChange can wait for whatever is still being saved before leaving Edit.
// Each button names the state it puts the page in, so no "Mode:" label.
const EditModeToggle = ({
  isEditing,
  onChange,
}: {
  isEditing: boolean;
  onChange: (isEditing: boolean) => void | Promise<void>;
}) => (
  <ToggleButtonGroup
    theme={ToggleButtonGroupTheme.defaultButtons}
    size={ButtonSize.medium}
    aria-label="Career tracks mode"
    buttons={[
      {
        title: (
          <span className="flex items-center gap-1.5">
            <TopicflowIcon type="eye" className="h-4 w-4" />
            Previewing
          </span>
        ),
        value: false,
        active: !isEditing,
      },
      {
        title: (
          <span className="flex items-center gap-1.5">
            <TopicflowIcon type="edit" className="h-4 w-4" />
            Editing
          </span>
        ),
        value: true,
        active: isEditing,
      },
    ]}
    onClick={(button) => {
      if (button.value !== undefined && button.value !== isEditing) {
        onChange(button.value);
      }
    }}
  />
);

export default EditModeToggle;
